import React from 'react';
import TransientThoughtFeedItem from './TransientThoughtFeedItem';

// Paused-interaction view. Visual parity with the live history feed: same
// bubble/cloud rendering, same per-index slot logic. No live animation —
// these are static, scrolled like the prev-comments scroll on the live screen.
const TransientThoughtResult = ({
  data = [],
  settings = {},
  colors = {},
  fontFamily,
  fontSize,
  isBubbleStyle,
  ttId
}) => {
  if (!data.length) {
    return (
      <div className="overflow-y-auto flex flex-col p-3 gap-y-2 z-10 h-full">
        <p className="text-base text-center font-OpenSans font-semibold text-neutral-60 lg:text-xl italic md:leading-6 lg:leading-7 overflow-hidden break-words">
          No comments to display
        </p>
      </div>
    );
  }

  return (
    <div className="overflow-y-auto w-full h-full">
      <div className="w-full flex flex-col gap-3 px-4 py-6 md:px-8">
        {data.map((_, chronoIdx) => {
          const displayIdx = data.length - 1 - chronoIdx;
          const item = data[displayIdx];
          return (
            <TransientThoughtFeedItem
              key={item.id || `${ttId}-result-${displayIdx}`}
              words={item.body || item.words}
              username={item.username}
              index={displayIdx}
              isBubbleStyle={isBubbleStyle}
              colors={colors}
              fontFamily={fontFamily}
              fontSize={fontSize}
              transientThoughtShowUsername={settings?.transientThoughtShowUsername}
              positionKey={displayIdx % 2 === 0 ? 'topLeft' : 'topRight'}
            />
          );
        })}
      </div>
    </div>
  );
};

export default TransientThoughtResult;
